import { render, staticRenderFns } from "./OrgCertificate.vue?vue&type=template&id=066c341a&scoped=true&"
import script from "./OrgCertificate.vue?vue&type=script&lang=js&"
export * from "./OrgCertificate.vue?vue&type=script&lang=js&"
import style0 from "./OrgCertificate.vue?vue&type=style&index=0&id=066c341a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c341a",
  null
  
)

export default component.exports